module.exports = __webpack_public_path__ + "img/j.7ba1891b.jpg";